import React from 'react';

import { Block, JsonLD, withConfig, withGridConfig } from '../common/Block.jsx';
import { EmptyContentPlaceholder } from '../layout/Builder.jsx';
import { Column, Row, Spaced } from '../common/Container.jsx';
import Defaults from '../layout/Defaults.jsx';
import Layout from '../common/Layout.jsx';
import { ContentContainer as _ContentContainer, withPaging } from '../common/List.jsx';
import { Footer, View as LoadingView } from '../common/Loading.jsx';
import Name from '../common/Name.jsx';
import * as RepresentativeListCell from './RepresentativeListCell.jsx';
import ScreenSize from '../common/ScreenSize.jsx';
import Utilities from '../common/Utilities.jsx';

const defaultColumnCount = 3;

class _RepresentativesListComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        this.setState({
            id: this.props.blockIdentifier
        });
        if (!this.props.data) {
            this.props.onLoad();
        }
    }

    render() {
        const isEmpty = this.props.data && (!this.props.data.representatives || this.props.data.representatives.length == 0);
        if (isEmpty) {
            if (this.props.builder) {
                const containerStyle = { width: '100%' };
                Utilities.copyObject(this.props.containerStyle, containerStyle);
                return <EmptyContentPlaceholder containerStyle={containerStyle} style={this.props.style}>You haven't added any representatives yet. Once you do, you'll see them here.</EmptyContentPlaceholder>
            }
            return null;
        }
        let animation, contentConfig;
        let columnCount = this.props.columnCount || defaultColumnCount;
        if (this.props.blockConfig.block) {
            animation = this.props.blockConfig.block.animation;
            if (this.props.blockConfig.block.cell && this.props.blockConfig.block.cell.desktop && this.props.blockConfig.block.cell.desktop.blocks && this.props.blockConfig.block.cell.desktop.blocks.length > 0) {
                contentConfig = this.props.blockConfig.block.cell;
            }
            switch (this.props.screenSize) {
                case ScreenSize.Mobile:
                    columnCount = this.props.blockConfig.block.columnsPhone || 1;
                    break;
                case ScreenSize.Tablet:
                    columnCount = this.props.blockConfig.block.columnsTablet || 3;
                    break;
            }
        }
        if (!contentConfig) {
            contentConfig = Defaults.Block[Name.Block.Representative.List].Cell
        }
        const columnSize = Layout.columnSize(columnCount);
        const listData = this.props.data && this.props.data.representatives || [];
        return (
            <>
                {
                    !this.props.data &&
                    <LoadingView />
                }
                {
                    this.props.data &&
                    <>
                        <ContentContainer className="cont--kit__wrapper" style={this.props.containerStyle}>
                            <Spaced className="cont--kit__content" style={this.props.style}>
                                <Row className="cont__row--custom">
                                    {listData.map((d, i) => (
                                        <Column
                                            key={i}
                                            className="col--custom"
                                            size={columnSize}
                                            style={this.props.builder ? { pointerEvents: 'none' } : undefined}>
                                            <RepresentativeListCell.RepresentativeCellContainer
                                                {...this.props}
                                                animation={animation}
                                                columnCount={columnCount}
                                                contentConfig={contentConfig}
                                                index={i}
                                                listData={listData}
                                                type="block"
                                                data={d} />
                                        </Column>
                                    ))}
                                </Row>
                            </Spaced>
                        </ContentContainer>
                        <Footer
                            active={this.props.active}
                            builder={this.props.builder}
                            hasMore={this.props.hasMore}
                            loading={this.props.loading}
                            onLoadMore={this.props.onLoadMore} />
                        <JsonLD
                            baseUrl={this.props.baseUrl}
                            builder={this.props.builder}
                            jsonLD={this.props.jsonLD}
                            path="representative"
                            querySub={this.props.querySub} />
                    </>
                }
            </>
        );
    }
}
const RepresentativesListComponent =
    withConfig(
        withPaging(
            withGridConfig(
                _RepresentativesListComponent,
                defaultColumnCount
            ),
            { path: 'representatives', resultKey: 'representatives' }));

function ContentContainer(props) {
    return (
        <_ContentContainer className={props.className} style={props.style} type="representatives">
            {props.children}
        </_ContentContainer>
    );
}

export default { Component: RepresentativesListComponent };